import * as _ from 'lodash';

import BaseResource from './base-resource';
import SiteResource from './site-resource';
import JsonApiReference from './jsonapi-reference';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';

export default class SubscriptionResource extends BaseResource {
  subscriptionType: string;
  recipient: string = null;
  deliveryMethod: string = null;
  site: SiteResource = new SiteResource();
  sendInterval: any;

  intervalName() {
    if (!this.sendInterval) {
      return '';
    } else if (this.sendInterval.type === 1) {
      return 'Daily';
    } else if (this.sendInterval.type === 2) {
      return 'Weekly';
    } else if (this.sendInterval.type === 3) {
      return 'Monthly';
    }
  }

  typeName() {
    return _.startCase(this.subscriptionType);
  }

  constructor(init?: Partial<SubscriptionResource>) {
    super(init, 'subscriptions');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/subscription-resource.ts